import ownerDocument from '../ownerDocument';
export default function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ownerWindow/ownerWindow.js
// module id = 1600
// module chunks = 22